module.exports = "/images/ny-street-1.jpg";